var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('carousel'),(!_vm.isLogged)?_c('login',{staticClass:"loginContent"}):_vm._e(),_c('footer-home')],1)}
var staticRenderFns = []

export { render, staticRenderFns }